<!-- HBC Go routes use their own layout (no main app wrapper) -->
<ng-container *ngIf="isHbcGoRoute$ | async; else mainAppLayout">
  <router-outlet #outlet="outlet" (activate)="onRouteActivate($event)"></router-outlet>
</ng-container>

<!-- Main app routes use web/mobile layout -->
<ng-template #mainAppLayout>
  <app-practice-agent-widget></app-practice-agent-widget>
  <ng-container [ngSwitch]="browserType$ | async">
    <app-mobile-layout *ngSwitchCase="BrowserTypes.Mobile">
      <ng-container *ngTemplateOutlet="routerOutlet"></ng-container>
    </app-mobile-layout>
    <app-web-layout *ngSwitchDefault>
      <ng-container *ngTemplateOutlet="routerOutlet"></ng-container>
    </app-web-layout>
  </ng-container>
</ng-template>

<ng-template #routerOutlet>
  <router-outlet #outlet="outlet" (activate)="onRouteActivate($event)"></router-outlet>
</ng-template>

<app-nora-recorder *ngIf="noraRecorderVisible$ | async"></app-nora-recorder>
